<div class="menu">
  <app-menu></app-menu>
</div>
<div class="main-content">
  <router-outlet></router-outlet>
</div>
